import {
  TBuildPermissionModelArgs,
  TPermissionModel,
} from '@/shared/features/permissions/utils/build-permission-model.types';
import { createGroupAncestryChecker } from '@/shared/features/permissions/utils/group-ancestry-checker';

export const buildPermissionModel = ({
  policies,
  resources,
  groups,
  readableIdsAuthoritative = true,
}: TBuildPermissionModelArgs): TPermissionModel => {
  const idToGroupId = new Map<string, Map<string, string | undefined>>();
  const idToTags = new Map<string, Map<string, string[]>>();
  const readableIds = new Map<string, Set<string>>();

  Object.entries(resources).forEach(([entity, items]) => {
    const groupMap = new Map<string, string | undefined>();
    const tagMap = new Map<string, string[]>();
    const idSet = new Set<string>();

    items.forEach(({ id, groupId, tags }) => {
      groupMap.set(id, groupId ?? undefined);
      idSet.add(id);
      if (tags?.length) {
        tagMap.set(id, tags);
      }
    });

    idToGroupId.set(entity, groupMap);
    idToTags.set(entity, tagMap);
    readableIds.set(entity, idSet);
  });

  const checker = createGroupAncestryChecker(
    groups?.map(({ groupId, parentGroupId }) => ({
      groupId,
      parentGroupId: parentGroupId ?? undefined,
    })),
  );

  return {
    policies,
    idToGroupId,
    idToTags,
    readableIds,
    readableIdsAuthoritative,
    isChildOf: (parentGroupId, childGroupId) =>
      Boolean(checker?.isChildOf(parentGroupId, childGroupId)),
  };
};
